"use client";

import styled from "styled-components";

import { poppins_caption_lg_medium } from "@frontend/design-system";

export const ViewTypeChangeButton = styled.button`
  display: flex;
  align-items: center;
  width: 17rem;
  height: 2.6rem;
  padding: 0.2rem;
  border: 0;
  border-radius: 0.4rem;
  background: #f1f3f5;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const ViewTypeOption = styled.span<{ $isActive: boolean }>`
  display: flex;
  flex: 1 1 0;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0.4rem 1rem;
  border-radius: 0.2rem;
  color: ${({ $isActive }) =>
    $isActive
      ? "var(--Color-Common-Text-Interactive-Primary, #0094ff)"
      : "var(--Color-Common-Text-Interactive-Secondary, #515c6c)"};
  background: ${({ $isActive }) =>
    $isActive ? "var(--Color-Common-Bg-primary, #fff)" : "transparent"};
  ${poppins_caption_lg_medium};

  transition: background-color 0.2s ease, color 0.2s ease;
`;
